import { FlexGroup, FlexItem, Link } from '@lithos';
import { TECTON_DOCUMENTATION_LINKS } from '../application-links';

// icons
import styled from '@emotion/styled';
import Book from '@svg/book.svg';

const NoDataWrapper = styled.div`
  color: ${({ theme }) => theme.colors.fullShade};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
`;

const DescriptionWrapper = styled.div`
  color: ${({ theme }) => theme.colors.subduedText};
  font-size: ${({ theme }) => theme.font.fontSizes.s};
  max-width: 260px;
`;

const NoData = () => {
  return (
    <>
      <FlexGroup gapSize="4" direction={'column'} alignItems="center">
        <FlexItem grow={1}>
          <NoDataWrapper>No Data Available</NoDataWrapper>
        </FlexItem>
        <FlexItem grow={1}>
          <DescriptionWrapper>This workspace has not been configured or there is not data yet.</DescriptionWrapper>
        </FlexItem>
        <FlexItem grow={1}>
          <Link
            name="Learn More"
            url={TECTON_DOCUMENTATION_LINKS.MONITORING_AND_DEBUGGING_ONLINE_SERVING}
            icon="Book"
          />
        </FlexItem>
      </FlexGroup>
    </>
  );
};

export default NoData;
